import {TabsProps} from "antd";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME, tabKeys} from "types/enums";
import List from "./List/List";
import Detail from "./Detail/Detail";

const items: TabsProps["items"] = [
  {
    key: tabKeys.MEDICINE_STORE.ALLOCATION_LIST,
    label: `Đơn thuốc kê`,
    children: <List></List>,
  },
  {
    key: tabKeys.MEDICINE_STORE.ALLOCATION_DETAIL,
    label: `Chi tiết đơn`,
    children: <Detail></Detail>,
  },
];

export {items};
